module.exports = __webpack_public_path__ + "static/media/whatPage.818ea771.jpg";